import privateHttpClient from '../privateHttpClient';
import { urlHttpGov } from '../../urls';
import AccessLogMapper from '../mappers/AccessLogMapper';

interface IAccessLogFilters {
    page?: number;
    perPage?: number;

    panelUserId?: number;
    roleId?: number;
    countyId?: number;

    method?: string;
    module?: string;

    success?: boolean;

    search?: string;

    startDate?: Date;
    endDate?: Date;
}

class AccessLogService {
    private baseURL: string = `${urlHttpGov}/panel/access-log`;

    async list(filters: IAccessLogFilters, signal: AbortSignal) {
        const { data } = await privateHttpClient.get(
            this.baseURL,
            {
                params: filters,
                signal
            }
        );

        return {
            data: data.data.map((accessLog: any) =>
                AccessLogMapper.toDomain(accessLog)
            ),
            meta: data.meta
        };
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new AccessLogService();